import React, { useState } from 'react'
import { host } from '#/configs'
import { logEvent } from '#/services/analytics'
import cn from '#/utils/classnames'
import BreadCrumbs from '../AboutCompany/components/BreadCrumbs/BreadCrumbs'
import GalleryList from './components/GalleryList'
import Layout from './components/Layout'
import styles from './styles.module.scss'
import { AllMapsProps, GalleryBannerProps } from './types'

export const GalleryHeader = ({ name }:{ name:string }) => (
  <header className={styles['th-maps-header']}>
    <BreadCrumbs categoryName={name} homeName='Home' pageName='Gallery' />
  </header>
)

export const GalleryBanner = ({ categories, logCategoryClick, selectedCategories }:
GalleryBannerProps) => (
  <div className={styles['th-gallery-banner']}>
    <h1 className={styles['th-banner-title']}>Map Gallery</h1>
    <h2 className={styles['th-banner-subtitle']}>Explore a collection of curated maps found on TopHap.</h2>
    <div className='flex flex-wrap justify-center space-x-3 py-4'>
      <span
        className={cn('inline-flex items-center py-0.5 px-2.5 mb-2 text-xs font-medium text-indigo-800 bg-white hover:bg-indigo-200 rounded-full cursor-pointer', { 'bg-indigo-200': selectedCategories.length === 0 })}
        onClick={() => {
          logCategoryClick('All Maps')
        }}
      >
        All Maps
      </span>
      {(categories && categories?.edges.length > 0) &&
                  categories?.edges.map(
                    (
                      category: {
                        node: {
                          name: string
                        }
                      },
                      index: number
                    ) => (
                      <span
                        key={index}
                        className={cn('inline-flex items-center py-0.5 px-2.5 mb-2 text-xs font-medium text-indigo-800 bg-white hover:bg-indigo-200 rounded-full cursor-pointer', { 'bg-indigo-200': selectedCategories.includes(category.node.name) })}
                        onClick={() => {
                          logCategoryClick(category.node.name)
                        }}
                      >
                        {category.node.name}
                      </span>
                    )
                  )}
    </div>
  </div>
)

const Maps: React.FC<AllMapsProps> = (
  { allMaps: { edges: articles }, preview, categories, intro }
) => {
  const [selectedCategories, setSelectedCategories] = useState< string[]>([])
  const meta = {
    title: 'Curated maps found on TopHap | TopHap Map Gallery',
    openGraph: {
      opengraphTitle:
        'Curated maps found on TopHap | TopHap Map Gallery',
      opengraphDescription:
        "Browse our collection of maps to see what's possible with TopHap. Discover use cases that will shed new light on real estate markets across the US."
    },
    image: `${host}/images/blog/tophap-blog.jpg`,
    site_name: 'Curated maps found on TopHap | TopHap Map Gallery'
  }
  function logCategoryClick(name: string) {
    if (name !== 'All Maps') {
      setSelectedCategories([name])
    } else {
      setSelectedCategories([])
    }
    logEvent('select_content', {
      content_type: 'gallery',
      item_id: 'filter_maps_pill',
      value: `${name}`
    })
  }

  return (
    <div className={styles['th-news-page']}>
      <Layout meta={meta} preview={preview}>
        <GalleryBanner
          categories={categories}
          logCategoryClick={logCategoryClick}
          selectedCategories={selectedCategories}
        />
        <div className='bg-gray-100'>
          <div className={styles['th-news-layout']}>
            <GalleryHeader name={selectedCategories[0] || 'All Maps'} />
            {articles.length > 0 && (
              <GalleryList
                articles={selectedCategories.length === 0 ? articles : articles.filter(article =>
                  article.node?.maps?.edges.some((category: any) =>
                    selectedCategories.includes(category.node.name)))}
                intro={intro}
              />
            )}
          </div>
        </div>
      </Layout>
    </div>
  )
}

export default Maps
